// assistants.js
const assistants = [
    {
      "name": "Catholic Catechism",
      "assistantId": "asst_n9FeSFOxeQZKezlCiUHGdkgR",
      "assistantDescription": "AI Assistant for the Catholic Catechism",
      "assistantLogo": "https://stmaryscathedral.ca/wp-content/uploads/2021/11/7.jpg"
    },
    {
      "name": "Ecumenical Councils",
      "assistantId": "asst_CpUSuopAlq2UWpLJPg06Fn7j",
      "assistantDescription": "AI Assistant for the 21 Ecumenical Council documents",
      "assistantLogo": "https://imagenes.catholic.net/imagenes_db/4ec2e6_logo_oficial_vaticano.gif"
    },
    // ... other assistants ...
  ];
  
  export default assistants;